import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _class;
import React, { Component } from 'react';
import intl from '../../utils/intl';
import { BlockContainer } from './index.style';
import SectionTitle from '../_components/SectionTitle';
import ConfigItem from '../_components/ConfigItem';
import withFormOperate from '../_components/withFormOperate';
import MotionTitle from '../_components/MotionTitle';
import { getMemoizedAssets, getStaticGif } from './util';
var SelectConfig = withFormOperate(_class = /*#__PURE__*/function (_Component) {
  _inherits(SelectConfig, _Component);
  var _super = _createSuper(SelectConfig);
  function SelectConfig() {
    var _this;
    _classCallCheck(this, SelectConfig);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.memoizedBaseSelect = getMemoizedAssets(_this.props.styleCounts.select, 'select/selection');
    _this.memoizedLabelSelect = getMemoizedAssets(_this.props.styleCounts.select, 'select/label-selection');
    _this.memoizedIconSelect = getMemoizedAssets(_this.props.styleCounts.select, 'select/icon-selection');
    _this.memoizedDateSelect = getMemoizedAssets(_this.props.styleCounts.select, 'select/date-selection');
    _this.memoizedDateTimeSelect = getMemoizedAssets(_this.props.styleCounts.select, 'select/date_time-selection');
    _this.memoizedRangeSelect = getMemoizedAssets(_this.props.styleCounts.select, 'select/scope-date-selection');
    _this.memoizedFastSelect = getMemoizedAssets(_this.props.styleCounts.select, 'select/fast');
    _this.memoizedTimeSelect = getMemoizedAssets(_this.props.styleCounts.select, 'select/time');
    _this.getMotions = getStaticGif(_this.props.styleCounts.inputMotion, 'select/motions');
    return _this;
  }
  _createClass(SelectConfig, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        value = _this$props.value,
        schema = _this$props.schema,
        handleChange = _this$props.handleChange;
      return /*#__PURE__*/React.createElement(BlockContainer, {
        id: "select-config"
      }, /*#__PURE__*/React.createElement(SectionTitle, {
        title: "\u9009\u62E9\u6846",
        titleTail: "Select"
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        name: "select",
        title: intl.get('hzero.hzeroTheme.page.basicSelect').d('基础下拉选择框'),
        simple: true,
        items: this.memoizedBaseSelect(schema),
        defaultSelected: value.select,
        onChange: handleChange('select')
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        name: "fastSelect",
        title: intl.get('hzero.hzeroTheme.page.fastSelect').d('快捷选择'),
        simple: true,
        items: this.memoizedFastSelect(schema),
        defaultSelected: value.select,
        onChange: handleChange('select')
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        name: "labelSelect",
        title: intl.get('hzero.hzeroTheme.page.labelSelect').d('标签选择框'),
        items: this.memoizedLabelSelect(schema),
        defaultSelected: value.select,
        onChange: handleChange('select')
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        name: "iconSelect",
        title: intl.get('hzero.hzeroTheme.page.iconSelect').d('图标选择'),
        items: this.memoizedIconSelect(schema),
        defaultSelected: value.select,
        onChange: handleChange('select')
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        name: "dateSelect",
        cols: 2,
        title: intl.get('hzero.hzeroTheme.page.dateSelect').d('日期选择'),
        items: this.memoizedDateSelect(schema),
        defaultSelected: value.select,
        onChange: handleChange('select')
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        name: "rangeSelect",
        cols: 2,
        title: intl.get('hzero.hzeroTheme.page.rangeDateSelect').d('范围日期选择'),
        items: this.memoizedRangeSelect(schema),
        defaultSelected: value.select,
        onChange: handleChange('select')
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        name: "dateTimeSelect",
        cols: 2,
        title: intl.get('hzero.hzeroTheme.page.dateAndTimeSelect').d('日期+时间选择'),
        items: this.memoizedDateTimeSelect(schema),
        defaultSelected: value.select,
        onChange: handleChange('select')
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        name: "timeSelect",
        cols: 2,
        title: intl.get('hzero.hzeroTheme.page.timeSelect').d('时间选择'),
        items: this.memoizedTimeSelect(schema),
        defaultSelected: value.select,
        onChange: handleChange('select')
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        name: "selectMotion",
        title: /*#__PURE__*/React.createElement(MotionTitle, {
          text: intl.get('hzero.hzeroTheme.page.animation').d('动效')
        }),
        defaultSelected: value.dropdownMotion,
        items: this.getMotions(schema),
        onChange: handleChange('dropdownMotion')
      }));
    }
  }]);
  return SelectConfig;
}(Component)) || _class;
export { SelectConfig as default };